import React from 'react';


export default function Wing() {
	return (
		<g className="wing wing--right">
			<path className="fill fill--dark" d="M327.16486,239.49071c4.52374,2.0405,6.43878,6.7592,6.4682,11.72177
				c0.10825,18.27867-2.18121,53.91426-32.6398,53.91426c-16.89166,0-27.98297-8.97876-27.98297-31.08014
				s13.69339-40.0181,30.58505-40.0181C312.96927,234.0285,321.46204,236.9184,327.16486,239.49071z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Chicken/Wing.js